<div class="container-fluid pt-5">
    <div class="row">
        <div class="col-9 col-md-6">
            <h2 class="fs-22 fw-500 lh-38 ps-lg-5"> <i class="fa fa-user-circle-o fs-20 me-3" aria-hidden="true"></i>
                Clients
            </h2>
        </div>
        <div class="col-3 col-md-6 justify-content-end d-flex pe-lg-5">
            <button class="btn btn-dark fs-16 fw-400 py-2 px-3" (click)="openModalClient(null)">
                <i class="fa fa-plus me-md-2" aria-hidden="true"></i><span class="d-none d-md-inline-flex">Add
                    Client</span>
            </button>
        </div>
        <hr class="mt-2" />
    </div>

    <div class="row px-lg-5 px-0">
        <div class="col-6 offset-6">
            <input type="text" placeholder="Search any value" class="form-control input-bg-set"
                [(ngModel)]="searchModal" (ngModelChange)="changeSearchValue()">
        </div>

        <ngx-datatable class="material mt-4 px-0" [rows]="allClientList" [columnMode]="ColumnMode.force"
            [headerHeight]="43" [footerHeight]="50" rowHeight="auto" [externalPaging]="true" [limit]="10"
            [count]="totalCount" (page)="setPage($event)" [scrollbarH]="true"
            [offset]="paginationModal.pagination.page - 1" (sort)="onSort($event)" [externalSorting]="true">


            <!-- <ngx-datatable-column name="Created Date" prop="created_at">
                <ng-template let-row="row" let-rowIndex="rowIndex" let-value="value" ngx-datatable-cell-template>
                    {{ row.created_at | date: 'MM/dd/yyyy':'UTC' }}
                </ng-template>
            </ngx-datatable-column> -->


            <ngx-datatable-column name="Full Name" prop="created_at">
                <ng-template let-row="row" let-rowIndex="rowIndex" let-value="value" ngx-datatable-cell-template>
                    {{ row.first_name }}{{ row.last_name }}
                </ng-template>
            </ngx-datatable-column>


            <ngx-datatable-column name="Email Address" prop="email" [width]="250"></ngx-datatable-column>


            <!-- <ngx-datatable-column name="Sites">
                <ng-template let-row="row" let-rowIndex="rowIndex" let-value="value" ngx-datatable-cell-template>
                    <button class="btn btn-primary text-white btn-sm" (click)="openModelViewAllSite(row)">View all
                        sites</button>
                </ng-template>
            </ngx-datatable-column> -->
            <ngx-datatable-column name="manage site" [width]="150">
                <ng-template let-row="row" let-rowIndex="rowIndex" let-value="value" ngx-datatable-cell-template>
                    <button type="button" class="btn btn-sm fs-22 pe-10" placement="start"
                        (click)="openModelManageAllSites(row)" ngbTooltip="Manage site">
                        <img src="../../assets/images/icons/web-optimization.png" class="manage-icon-site" />
                    </button>
                </ng-template>
            </ngx-datatable-column>

            <ngx-datatable-column name="Enable/Disable" [width]="150">
                <ng-template let-row="row" let-rowIndex="rowIndex" let-value="value" ngx-datatable-cell-template>
                    <div class="form-check form-switch">
                        <input class="form-check-input custom-switch" type="checkbox" role="switch" id="flexSwitchCheckChecked"
                            (click)="onChange(row)" [checked]="!row.is_blocked">
                    </div>
                </ng-template>
            </ngx-datatable-column>

            <!-- <ngx-datatable-column name="Action">
                <ng-template let-row="row" let-rowIndex="rowIndex" let-value="value" ngx-datatable-cell-template>

                    <button type="button" class="btn btn-sm fs-5" (click)="changePassword(row)" title="Change Password">
                        <i class="fa fa-unlock-alt" aria-hidden="true"></i>
                    </button>

                    <button type="button" class="btn btn-sm fs-5" title="Edit Client" (click)="openModalClient(row)">
                        <i class="fa fa-pencil" aria-hidden="true"></i>
                    </button>

                    <button type="button" class="btn btn-link fs-5" title="Delete Client"
                        (click)="onDelete(row, rowIndex)">
                        <i class="fa fa-trash" aria-hidden="true"></i>
                    </button>

                </ng-template>
            </ngx-datatable-column> -->

            <ngx-datatable-column name="Action" [width]="250" [canAutoResize]="false" [sortable]="false"
                [draggable]="false" class="manage-icon-center">
                <ng-template let-row="row" let-rowIndex="rowIndex" ngx-datatable-cell-template>
                    <div class="d-flex justify-content-center gap-2 w-100">

                        <button type="button" class="btn btn-sm fs-5" (click)="changePassword(row)"
                            ngbTooltip="Change Password" placement="start">
                            <i class="fa fa-unlock-alt" aria-hidden="true"></i>
                        </button>

                        <button type="button" class="btn btn-sm fs-5" (click)="openModalClient(row)"
                            ngbTooltip="Edit Client" placement="start">
                            <i class="fa fa-pencil" aria-hidden="true"></i>
                        </button>

                        <button type="button" class="btn btn-link fs-5" (click)="onDelete(row, rowIndex)"
                            ngbTooltip="Delete Client" placement="start">
                            <i class="fa fa-trash" aria-hidden="true"></i>
                        </button>
                    </div>
                </ng-template>
            </ngx-datatable-column>

            <!-- <ngx-datatable-column name="Reset Password">
                <ng-template let-row="row" let-rowIndex="rowIndex" let-value="value" ngx-datatable-cell-template>
                    <button type="button" class="btn btn-sm  fs-5" (click)="changePassword(row)">
                        <i class="fa fa-unlock-alt" aria-hidden="true"></i>
                    </button>
                    
                </ng-template>
            </ngx-datatable-column>

            <ngx-datatable-column name="Edit" [width]="70">
                <ng-template let-row="row" let-rowIndex="rowIndex" let-value="value" ngx-datatable-cell-template>
                    <button type="button" class="btn btn-sm fs-5">
                        <i class="fa fa-pencil" aria-hidden="true" (click)="openModalClient(row)"></i>
                    </button>
                </ng-template>
            </ngx-datatable-column>

            <ngx-datatable-column name="Delete" [width]="70">
                <ng-template let-row="row" let-rowIndex="rowIndex" let-value="value" ngx-datatable-cell-template>
                    <button type="button" class="btn btn-link fs-5">
                        <i class="fa fa-trash" aria-hidden="true" (click)="onDelete(row,rowIndex)"></i>
                    </button>
                </ng-template>
            </ngx-datatable-column> -->

        </ngx-datatable>
    </div>
</div>